import type { CriteriaType, CriteriaTypeLabel } from '../types/generic';
import type { ContentType } from '../types/value';

interface Rule {
    criteria: CriteriaType;
    label: CriteriaTypeLabel;
}

const RULES: Readonly<Record<string, Rule>> = {
    equals: { criteria: 'EQUAL', label: 'Equals' },
    notEquals: { criteria: 'NOT_EQUAL', label: 'Not equal' },
    greaterThan: { criteria: 'GREATER_THAN', label: 'Greater than' },
    greaterThanEqualTo: { criteria: 'GREATER_THAN_OR_EQUAL', label: 'Greater than or equal to' },
    lessThan: { criteria: 'LESS_THAN', label: 'Less than' },
    lessThanEqualTo: { criteria: 'LESS_THAN_OR_EQUAL', label: 'Less than or equal to' },
    startsWith: { criteria: 'STARTS_WITH', label: 'Starts' },
    endsWith: { criteria: 'ENDS_WITH', label: 'Ends' },
    contains: { criteria: 'CONTAINS', label: 'Contains' },
    isEmpty: { criteria: 'IS_EMPTY', label: 'Empty' },
    allEqual: { criteria: 'ALL_EQUAL', label: 'All Equal' },
    anyEqual: { criteria: 'ANY_EQUAL', label: 'Any Equal' },
};

export const criteriaOptions: Readonly<Record<ContentType | 'ContentListProperty', Rule[]>> = {
    ContentString: [
        RULES['equals'],
        RULES['notEquals'],
        RULES['greaterThan'],
        RULES['greaterThanEqualTo'],
        RULES['lessThan'],
        RULES['lessThanEqualTo'],
        RULES['startsWith'],
        RULES['endsWith'],
        RULES['contains'],
        RULES['isEmpty'],
    ],
    ContentBoolean: [RULES['equals'], RULES['notEquals'], RULES['isEmpty']],
    ContentContent: [
        RULES['equals'],
        RULES['notEquals'],
        RULES['greaterThan'],
        RULES['greaterThanEqualTo'],
        RULES['lessThan'],
        RULES['lessThanEqualTo'],
        RULES['startsWith'],
        RULES['endsWith'],
        RULES['contains'],
        RULES['isEmpty'],
    ],
    ContentPassword: [
        RULES['equals'],
        RULES['notEquals'],
        RULES['greaterThan'],
        RULES['greaterThanEqualTo'],
        RULES['lessThan'],
        RULES['lessThanEqualTo'],
        RULES['startsWith'],
        RULES['endsWith'],
        RULES['contains'],
        RULES['isEmpty'],
    ],
    ContentEncrypted: [
        RULES['equals'],
        RULES['notEquals'],
        RULES['greaterThan'],
        RULES['greaterThanEqualTo'],
        RULES['lessThan'],
        RULES['lessThanEqualTo'],
        RULES['startsWith'],
        RULES['endsWith'],
        RULES['contains'],
        RULES['isEmpty'],
    ],
    ContentDateTime: [
        RULES['equals'],
        RULES['notEquals'],
        RULES['greaterThan'],
        RULES['greaterThanEqualTo'],
        RULES['lessThan'],
        RULES['lessThanEqualTo'],
        RULES['isEmpty'],
    ],
    ContentDate: [
        RULES['equals'],
        RULES['notEquals'],
        RULES['greaterThan'],
        RULES['greaterThanEqualTo'],
        RULES['lessThan'],
        RULES['lessThanEqualTo'],
        RULES['isEmpty'],
    ],
    ContentNumber: [
        RULES['equals'],
        RULES['notEquals'],
        RULES['greaterThan'],
        RULES['greaterThanEqualTo'],
        RULES['lessThan'],
        RULES['lessThanEqualTo'],
        RULES['isEmpty'],
    ],
    ContentList: [RULES['isEmpty']],
    ContentListProperty: [RULES['allEqual'], RULES['anyEqual']],
    ContentObject: [RULES['isEmpty']],
    ContentCode: [
        RULES['equals'],
        RULES['notEquals'],
        RULES['greaterThan'],
        RULES['greaterThanEqualTo'],
        RULES['lessThan'],
        RULES['lessThanEqualTo'],
        RULES['startsWith'],
        RULES['endsWith'],
        RULES['contains'],
        RULES['isEmpty'],
    ],
};
